import { useEffect, useState } from "react";

/**
 * True at Tailwind's `lg` breakpoint and up (1024px). MUST match Tailwind's lg
 * so the JS "is desktop?" decision agrees with the `tw:lg:*` CSS that styles the
 * same layout. (It used to be 992px / Bootstrap lg, which left a 992–1023px
 * split-brain zone: JS rendered desktop variants while the CSS was still mobile.)
 * Lets a page inject header content only on desktop, so mobile doesn't get an
 * empty/hidden header row reserving space.
 */
export function useIsDesktop(query = "(min-width: 1024px)"): boolean {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const update = () => setIsDesktop(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, [query]);

  return isDesktop;
}
